import { VariableSelector } from '@atoms/dataSelectors/variableSelector/variableSelector';
import { InputField } from '@atoms/input';
import BlockBase from '@components/dnd/base/blockBase';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { useAtom } from '@hooks/useAtom';
import EndControlsFB from '@library/formBuilder/endControls';
import { FormControl, FormLabel } from '@mui/joy';
import type { DNDBlock } from '@stratumn/studio-shared';
import { Hash, type LucideIcon } from 'lucide-react';
import { observer } from 'mobx-react';
import type { ChangeEvent } from 'react';
import { useParams } from 'react-router-dom';
import { ParamsList } from '@/routes/routes.types';

import { initialTINumberData } from './number.data';

export const NumberIcon: LucideIcon = Hash;

const Number = (block: DNDBlock) => {
  const workflowId = useParams()[ParamsList.WorkflowId] as string;

  const atom = useAtom({
    type: 'TI_Number',
    sourceId: block.id,
    parentId: workflowId,
    parentKind: 'traceInfo',
    initialData: {
      ...initialTINumberData,
      /* eslint-disable */
      selectedVariable: block.other?.selectedVariableRef!
    }
  });

  if (!atom) {
    return null;
  }

  const onTitleChange = (event: ChangeEvent<HTMLInputElement>) => {
    atom.data.title = event.target.value;
  };

  return (
    <BlockBase
      dataItem={atom}
      dndBlock={block}
      endControls={
        <EndControlsFB dataItem={atom} dndBlock={block} hasRequired={false} />
      }
      icon={NumberIcon}
      title={atom.data.title}
    >
      <Column $width="200px">
        <InputField
          label="Widget title"
          onChange={onTitleChange}
          placeholder="Aa"
          value={atom.data.title}
        />
      </Column>
      <Column $width="200px">
        <FormControl size="sm">
          <FormLabel> State variable</FormLabel>
          <VariableSelector
            disabled
            editable={false}
            selectedRef={atom.data.selectedVariable}
          />
        </FormControl>
      </Column>
    </BlockBase>
  );
};

export default observer(Number);
